/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <GlobalGraph class="graph" v-if="series.length" :series="series" :xAxisData="xAxis" :yAxis="yAxis" :legend="legend" :theme="theme" :loading="loading" />
</template>

<script>
import moment from 'moment'
import service from '@/services/Scb.js'
import { mapGettersMixin } from '@/util/mixin/index.js'
import GlobalGraph from '@/components/common/GlobalGraph.vue'

import {
  mapGetters,
  mapMutations
} from 'vuex'

export default {
  mixins: [ mapGettersMixin ],
  props: ['param', 'date'],
  components: {
    GlobalGraph
  },
  data() {
    return {
      loading: false,
      interval: null,
      series: [],
      xAxis: [],
      legend: {},
      type: 'inverter'
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    watchParamAndDate() {
      const connectedParam = Object.keys(this.param)
      return `${this.date} ${connectedParam.toString()} ${connectedParam.map(el => this.param[el]).toString()}`
    },
    yAxis() {
      return [{
        name: `${this.$t('Current')} (A)`,
        axisLabel: {
          formatter: '{value}',
          rotate: 40
        }
      }]
    }
  },
  mounted() {
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getStringData()
    },
    async getStringData() {
      let param = this.getParam('graph')
      try {
        this.loading = true
        this.series = []
        let response = await service.getStringDataGraph(param)
        this.loading = false
        Object.keys(response.data.message.response).forEach(current => {
          this.series.push({
            name: current,
            type: 'line',
            data: response.data.message.response[current]
          })
        })
        this.legend = response.data.message.legenData
        this.xAxis = response.data.message.axis
      } catch (err) {
        this.loading = false
      }
    },
    getParam(type) {
      const temp = this.param
      return {
        plantId: this.getSelectedPlantId,
        dateTo: this.date,
        dateFrom: this.date,
        type: this.type,
        idList: temp
      }
    }
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    },
    watchParamAndDate() {
      this.callAllApi()
    }
  }
}
</script>

<style scoped>
.graph {
    width: 100%;
    height: 370px;
  }
</style>
